import createIcon from '../../createIcon';

/**
 * @component @name OnexMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC41IDdIOC41VjE3SDYuNVY5SDQuNVY3Wk0xNi4zMyAxMS43MkwxOS4xNiA3SDE2LjgzTDE1LjE3IDkuNzdMMTMuNSA3SDExLjE3TDE0IDExLjcyTDEwLjgzIDE3SDEzLjE2TDE1LjE2IDEzLjY2TDE3LjE2IDE3SDE5LjVMMTYuMzMgMTEuNzJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OnexMobiledata = createIcon('OnexMobiledata', [
  [
    'path',
    {
      d: 'M4.5 7H8.5V17H6.5V9H4.5V7ZM16.33 11.72L19.16 7H16.83L15.17 9.77L13.5 7H11.17L14 11.72L10.83 17H13.16L15.16 13.66L17.16 17H19.5L16.33 11.72Z',
      key: 'gi5br2',
    },
  ],
]);

export default OnexMobiledata;
